import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TabContent from 'reactstrap/lib/TabContent';
import TabPane from 'reactstrap/lib/TabPane';
import classnames from 'classnames';
import Dynamic from 'components/widgets/engines/dynamic';
import Hotel from 'components/widgets/engines/hotel';
import Flight from 'components/widgets/engines/flight';
import FlightTemp from 'components/widgets/engines/flightTemp';
import CarTemp from 'components/widgets/engines/carTemp';
import Car from 'components/widgets/engines/car';
import Cruise from 'components/widgets/engines/cruise';
import Sunquest from 'components/widgets/engines/sunquest';
import Addons from 'components/widgets/engines/addons';
import Groups from 'components/widgets/engines/groups';
import Viator from 'components/widgets/engines/viator';
import Lang from 'libraries/Lang';

class Engine extends Component {
    constructor(props) {
        super(props);

        // const keys = Object.keys(props.config);
        // const first = keys.find(key => props.config[key] !== false);
        this.state = {
            activeTab: props.module,
            Traveltoken: props.token,
            TravelRedirect: props.redirectTo,
            showAll: false,
            displayShowAllButton: true,
            displayCloseAllButton: false,
            WindowSize: window.innerWidth,
            commonDateFormat: props.commonDateFormat,

        };
        this.handleResize = this.handleResize.bind(this);
    }

    changeTab(tab) {
        const { activeTab } = this.state;

        if (activeTab !== tab) {
            this.setState({
                activeTab: tab,
                showAll: false,
                displayCloseAllButton: false,
                displayShowAllButton: true,
            });
        }
    }

    componentDidMount() {
        const message = document.getElementById('langBasedMessage').getAttribute('value');
        const convertedMessage = JSON.parse(message);
        this.setState({ LanguageBasedLabel: convertedMessage });

        window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.setState({ WindowSize: window.innerWidth });
    }

    showAll() {
        this.setState({
            showAll: true,
            displayShowAllButton: false,
            displayCloseAllButton: true,
        });
    }

    closeAll() {
        this.setState({
            showAll: false,
            displayCloseAllButton: false,
            displayShowAllButton: true,
        });
    }

    render() {
        const {
            activeTab, Traveltoken, TravelRedirect, showAll, displayShowAllButton, displayCloseAllButton, WindowSize, commonDateFormat,
        } = this.state;
        // const { config } = this.props;

        return (
            <div className="search-widget">
                <div className="d-flex flex-wrap justify-content-between align-items-start">
                    <ul className="list-unstyled nav nav-tabs no-gutters w-100" role="tablist">
                        <li
                            className={classnames('nav-item flex-grow-1 mr-md-1 mb-1 mb-md-0', { hide: (activeTab != 'flight' && !showAll) })}
                            role="none"
                        >
                            <a
                                className={classnames({ active: activeTab === 'flight', 'd-flex justify-content-md-center align-items-center': true })}
                                href="#flights"
                                role="tab"
                                aria-controls="flights"
                                onClick={() => { this.changeTab('flight'); }}
                            >

                                <svg className="icon mr-3 mr-xl-3 mr-lg-2" aria-hidden="true">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-plane-take-off" />
                                </svg>
                                <div className="align-self-center mt-1">
                                    <span className="nav-title font-weight-bold">{Lang.trans('engine.flights')}</span>
                                </div>
                            </a>
                        </li>
                        <li className={classnames('nav-item flex-grow-1 mr-md-1 mb-1 mb-md-0', { hide: (activeTab != 'dynamic' && !showAll) })} role="none">
                            <a
                                className={classnames({ active: activeTab === 'dynamic', 'd-flex justify-content-md-center align-items-center': true })}
                                href="#travelgenie"
                                role="tab"
                                aria-controls="travelgenie"
                                onClick={() => { this.changeTab('dynamic'); }}
                            >
                                <svg className="icon mr-3 mr-xl-3 mr-lg-2" aria-hidden="true">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-genie-lamp" />
                                </svg>
                                <div className="align-self-center mt-1">
                                    <span className="nav-title font-weight-bold">{Lang.trans('engine_travelgenie.title')}</span>
                                </div>
                            </a>
                        </li>
                        <li className={classnames('nav-item flex-grow-1 mr-md-1 mb-1 mb-md-0', { hide: (activeTab != 'hotel' && !showAll) })} role="none">
                            <a
                                className={classnames({ active: activeTab === 'hotel', 'd-flex justify-content-md-center align-items-center': true })}
                                href="#hotels"
                                role="tab"
                                aria-controls="hotels"
                                onClick={() => { this.changeTab('hotel'); }}
                            >
                                <svg className="icon mr-3 mr-xl-3 mr-lg-2" aria-hidden="true">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-hotel" />
                                </svg>
                                <div className="align-self-center mt-1">
                                    <span className="nav-title font-weight-bold">{Lang.trans('engine.hotels')}</span>
                                </div>
                            </a>
                        </li>
                        <li className={classnames('nav-item flex-grow-1 mr-md-1 mb-1 mb-md-0', { hide: (activeTab != 'car' && !showAll) })} role="none">
                            <a
                                className={classnames({ active: activeTab === 'car', 'd-flex justify-content-md-center align-items-center': true })}
                                href="#cars"
                                role="tab"
                                aria-controls="cars"
                                onClick={() => { this.changeTab('car'); }}
                            >
                                <svg className="icon mr-3 mr-xl-3 mr-lg-2" aria-hidden="true">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-car" />
                                </svg>
                                <div className="align-self-center mt-1">
                                    <span className="nav-title font-weight-bold">{Lang.trans('engine.cars')}</span>
                                </div>
                            </a>
                        </li>
                        <li className={classnames('nav-item flex-grow-1 mr-md-1 mb-1 mb-md-0', { hide: (activeTab != 'cruise' && !showAll) })} role="none">
                            <a
                                className={classnames({ active: activeTab === 'cruise', 'd-flex justify-content-md-center align-items-center': true })}
                                href="#cruises"
                                role="tab"
                                aria-controls="cruises"
                                onClick={() => { this.changeTab('cruise'); }}
                            >
                                <svg className="icon mr-3 mr-xl-3 mr-lg-2" aria-hidden="true">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-cruises" />
                                </svg>
                                <div className="align-self-center mt-1">
                                    <span className="nav-title font-weight-bold">{Lang.trans('engine.cruises')}</span>
                                </div>
                            </a>
                        </li>
                        <li className={classnames('nav-item flex-grow-1 mr-md-1 mb-1 mb-md-0', { hide: (activeTab != 'sunquest' && !showAll) })} role="none">
                            <a
                                className={classnames({ active: activeTab === 'sunquest', 'd-flex justify-content-md-center align-items-center': true })}
                                href="#sunquest"
                                role="tab"
                                aria-controls="sunquest"
                                onClick={() => { this.changeTab('sunquest'); }}
                            >
                                <svg className="icon mr-3 mr-xl-3 mr-lg-2" aria-hidden="true">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-sunquest" />
                                </svg>
                                <div className="align-self-center mt-1">
                                    <span className="nav-title font-weight-bold">Sunquest</span>
                                </div>
                            </a>
                        </li>
                        <li className={classnames('nav-item flex-grow-1 mr-md-1 mb-1 mb-md-0', { hide: (activeTab != 'addons' && !showAll) })} role="none">
                            <a
                                className={classnames({ active: activeTab === 'addons', 'd-flex justify-content-md-center align-items-center': true })}
                                href="#add-ons"
                                // href="#viator"
                                role="tab"
                                aria-controls="add-ons"
                                onClick={() => { this.changeTab('addons'); }}
                            >
                                <svg className="icon mr-3 mr-xl-3 mr-lg-2" aria-hidden="true">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-add-ons" />
                                </svg>
                                <div className="align-self-center mt-1">
                                    <span className="nav-title font-weight-bold">{Lang.trans('engine.addons')}</span>
                                    {/* <span className="nav-title font-weight-bold">Viator</span> */}

                                </div>
                            </a>
                        </li>
                        <li className={classnames('nav-item flex-grow-1 mr-md-1 mb-1 mb-md-0', { hide: (activeTab != 'groups' && !showAll) })} role="none">
                            <a
                                className={classnames({ active: activeTab === 'groups', 'd-flex justify-content-md-center align-items-center': true })}
                                href="#groups"
                                // href="/launch/groups?page=travelgenie"
                                role="tab"
                                aria-controls="groups"
                                onClick={() => { this.changeTab('groups'); }}
                            >
                                <svg className="icon mr-3 mr-xl-3 mr-lg-2" aria-hidden="true">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-users-multiple" />
                                </svg>
                                <div className="align-self-center mt-1">
                                    <span className="nav-title font-weight-bold">{Lang.trans('groups.group_label')}</span>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <div className="d-flex d-md-none align-items-center justify-content-end w-100 ">
                        <button
                            onClick={() => { this.closeAll(); }}
                            className={classnames('btn-unstyled rounded-sm px-2 py-1 bg-white font-weight-bold box-shadow m-2', { hide: !displayCloseAllButton })}
                        ><div className="d-flex align-items-center">
                                <svg className="icon mr-2 text-primary" width="100%" height="100%">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-close-circle-blank" />
                                </svg>
                                close
                            </div>
                        </button>
                        <button
                            onClick={() => { this.showAll(); }}
                            className={classnames('btn-unstyled rounded-sm px-2 py-1 bg-white position-absolute top-right font-weight-bold box-shadow m-2', { hide: !displayShowAllButton })}
                            style={{ top: '0' }}
                        >
                            <div className="d-flex align-items-center">
                                <svg className="icon mr-2 text-primary" width="100%" height="100%">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-plus-circle-border" />
                                </svg>
                                More
                            </div>
                        </button>
                    </div>

                </div>
                {(!showAll || WindowSize > 767) && (
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="flight">
                            {/* <Flight Traveltoken={Traveltoken} TravelRedirect={TravelRedirect} /> */}
                            <FlightTemp Traveltoken={Traveltoken} TravelRedirect={TravelRedirect} activeTab={activeTab} />
                        </TabPane>
                        <TabPane tabId="dynamic">
                            <Dynamic Traveltoken={Traveltoken} TravelRedirect={TravelRedirect} activeTab={activeTab} commonDateFormat={commonDateFormat} />
                        </TabPane>
                        <TabPane tabId="hotel">
                            <Hotel Traveltoken={Traveltoken} TravelRedirect={TravelRedirect} activeTab={activeTab} commonDateFormat={commonDateFormat} />
                        </TabPane>
                        <TabPane tabId="cruise">
                            <Cruise Traveltoken={Traveltoken} TravelRedirect={TravelRedirect} activeTab={activeTab} commonDateFormat={commonDateFormat} />
                        </TabPane>
                        <TabPane tabId="car">
                            {/* <Car Traveltoken={Traveltoken} TravelRedirect={TravelRedirect} /> */}
                            <CarTemp Traveltoken={Traveltoken} TravelRedirect={TravelRedirect} activeTab={activeTab} />
                        </TabPane>
                        <TabPane tabId="sunquest">
                            <Sunquest Traveltoken={Traveltoken} TravelRedirect={TravelRedirect} activeTab={activeTab} commonDateFormat={commonDateFormat} />
                        </TabPane>
                        {/* <TabPane tabId="addons">
                        <Addons Traveltoken={Traveltoken} TravelRedirect={TravelRedirect} />
                    </TabPane> */}
                        <TabPane tabId="addons">
                            <Viator Traveltoken={Traveltoken} TravelRedirect={TravelRedirect} activeTab={activeTab} commonDateFormat={commonDateFormat} />
                        </TabPane>
                        <TabPane tabId="groups">
                            <Groups Traveltoken={Traveltoken} TravelRedirect={TravelRedirect} activeTab={activeTab} />
                        </TabPane>
                    </TabContent>
                )}
            </div>
        );
    }
}

Engine.propTypes = {
    // config: PropTypes.instanceOf(Object).isRequired,
};

export default Engine;
